import moment from 'moment'
import {Template, Component} from '@scoutgg/ftw/source/lib'
import template from './form-field.jade'

const value = Symbol('value')
const supported = [
  'input',
  'textarea',
  'select',
  '[contenteditable]',
]

@Component('sporty')
@Template(template)
export default class FormField extends HTMLElement {
  attached() {
    this.listen()
  }

  listen() {
    if(this.input) {
      this.input.removeEventListener(this.event, this.listener)
      this.listener = null
      this.input = null
      this.event = null
    }

    const input = this.querySelector(supported)
    if(!input) return

    this.input = input
    if(input.type === 'checkbox') {
      this.valueProp = 'checked'
      this.event = 'changed'
    } else if(input.type === 'radio') {
      this.valueProp = 'checked'
      this.event = 'change'
    } else if(input.tagName === 'INPUT') {
      this.valueProp = 'value'
      this.event = 'input'
    } else if(input.tagName === 'SELECT') {
      this.valueProp = 'value'
      this.event = 'change'
    }

    if(this[value]) input[this.valueProp] = this[value]

    if(this.event) {
      this.listener = ({target}) => {
        this.emit('valueChanged', {value: this.value})
      }
      input.addEventListener(this.event, this.listener)
    }
  }

  set value(v) {
    const input = this.input
    if(input && input.type === 'date') {
      v = v ? moment(v).format('YYYY-MM-DD') : ''
    }
    this[value] = v
    if(!input) return
    input[this.valueProp] = v
  }

  get value() {
    const input = this.input
    if(!input) return
    if(!input.validity || input.validity.valid) {
      this[value] = input[this.valueProp]
    }
    return this.input.value||this.typed 
  }

  get typed() {
    if(this.input.type === 'number') return +this[value]
    return this[value]
  }
}
